import BaseRepository from '@/api/repositories/BaseRepository';

export default class ProcessRepository extends BaseRepository {
	getRepairPlan(processId, options = {}) {
		return this.get(':processId/repairPlan', {
			processId: processId,
			...options,
		});
	}

	get endpoint() {
		return 'api/damagecases';
	}

	storeProcessOrderDocumentation(data, params = {}) {
		return this.post('order_documentation', params, data);
	}

	storeProcessComprehensive(data, params = {}) {
		return this.post('comprehensive', params, data);
	}
}
